export default {
  type: "Feature",
  properties: {
    name: "Ханбогд",
    location: [42.29576, 107.2934],
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[43.197260363204684, 107.19890339503985]]],
  },
};
